<template>
  <div></div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import store from '@/store/index'
import mutationsTypes from '@/store/mutationTypes'
import getApiMock from '@/views/user/getApiMock'
import axios from 'axios'
import { commonUtil } from '@/util'

export default {
  name: 'MailVerify',
  data: () => {
    return {
      userInfo: {}
    }
  },
  methods: {
    ...mapGetters('User', ['mailVerifyUrl', 'getUserInfoFromState']),
    ...mapMutations('Auth', [mutationsTypes.AUTH_SET_MAIL_VERIFY_URL]),
    ...mapActions('User', ['getUserInfoFromApi']),
    ...mapActions('Auth', ['requestMailVerify']),
    /**
     * ユーザ情報取得APIを実行しユーザ情報取得成功したら
     * リクエストで受け取ったredirectUrlを実行しTopへ遷移する
     * ユーザ情報取得APIを実行し失敗したらログイン画面に遷移する（ログイン完了後にリクエストで受け取ったredirectUrlを実行）
     */
    async checkUserInfo() {
      await this.getUserInfoFromApi()
      this.userInfo = this.getUserInfoFromState()
      if (this.userInfo) {
        // メール認確認用URLに対しgetリクエスト
        const verified = await this.requestMailVerify(
          this.$route.query.redirectUrl
        )
        if (verified) {
          // マスタデータを一括取得
          // await commonUtil.bulkGetMasterData()

          // 会社情報等登録済みならTopへ
          if (this.userInfo.organization.name) {
            this.$router.push({ name: 'dashboard' }).catch(() => {})
          } else {
            this.$router.push({ name: 'user.profile' }).catch(() => {})
          }
        }
        this.setMailVerifyUrl('')
      } else {
        // ユーザ情報が取得できなかった場合はべつのブラウザで遷移してきているのでログイン画面に遷移させる
        this.$router.push({ name: 'Login' }).catch(() => {})
      }
    },
    setMailVerifyUrl(requesturl) {
      // ログイン画面でも使用するのでグローバル
      this[mutationsTypes.AUTH_SET_MAIL_VERIFY_URL]({
        mailVerifyUrl: requesturl
      })
    }
  },
  created() {
    // ログイン画面でも使用するのでグローバルにする
    this.setMailVerifyUrl(this.$route.query.redirectUrl)
    this.checkUserInfo()
  }
}
</script>
